const styles = () => ({
  width: '100%',
  paddingTop: '20px',
  borderTop: '1px solid #E3E3E3',

  '.MuiMenuItem-root': {
    '.MuiTypography-root': {
      fontSize: '13px',
      color: '#4D4D4D',
      maxWidth: '100%',
      span: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      svg: {
        height: '15px',
        width: '15px',
        padding: '6px',
        color: '#FEB050',
        background: '#FFEBD3',
        borderRadius: '500px',
        marginRight: '5px',
      },
    },

    '&:nth-of-type(3n+2)': {
      svg: {
        color: '#009EFF',
        background: '#DEEFFF',
      },
    },
    '&:nth-of-type(3n+3)': {
      svg: {
        color: '#1CDEB2',
        background: '#CCF1E9',
      },
    },
  },
});

export default styles;
